import { gptExtensionsLogger } from '../Common/GPT/loggers';

export const runGptExtensions = function (gptExtensions, id) {
    const start = performance.now();

    gptExtensionsLogger.debug(`Running ${id} extensions, ${gptExtensions[id]?.length || 0} found`);
    if (gptExtensions[id]) {
        gptExtensions[id].sort((a, b) => a.execOrder - b.execOrder);
        gptExtensions[id].forEach((extension) => {
            extension.fn();
            if (typeof extension.callback === 'function') {
                extension.callback();
            }
        });
    }

    gptExtensionsLogger.debug(`Running ${id} extensions took ${(performance.now() - start).toFixed(2)} ms`);
};

export function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has(param)) {
        const value = urlParams.get(param);

        return value === null ? '' : value;
    }

    return null;
}

if (!EventTarget.prototype.runAt) {
    EventTarget.prototype.runAt = function (eventName, handler, options = {}) {
        if (typeof options.preCheck === 'function' && options.preCheck()) {
            const simulatedEvent = new CustomEvent(eventName);

            handler(simulatedEvent);
            if (options.once) return;
        }

        this.addEventListener(eventName, handler, options);
    };
}

export function runAtDOMContentLoaded(fn) {
    document.runAt('DOMContentLoaded', fn, {
        preCheck: () => document.readyState !== 'loading',
        once: true,
    });
}
